export function can(roleId, userPermissions = [], permission) {
  if(roleId === "Superadmin")
    return true;
  return  userPermissions.includes(permission);
}

export function canAny(roleId, userPermissions = [], permissions = []) {
  if(roleId === "Superadmin")
    return true;
  return permissions.some(p => userPermissions.includes(p));
}

export function canAll(roleId, userPermissions = [], permissions = []) {
  if(roleId === "Superadmin")
    return true;
  return permissions.every(p => userPermissions.includes(p));
}